module.exports = __webpack_public_path__ + "static/media/iq.fca3d384.svg";